import Http from '../Http'
import { IQuery } from '../interfaces/Query'
import { IToken } from '../interfaces/Token'
import { Routes } from '../routes'

export default class Adjustment extends Http {
  public async create(token: IToken, data: IQuery = {}): Promise<any> {
    return (await this.spreeResponse(
      'post',
      Routes.adjustmentsPath(),
      token,
      {},
      data,
    )) as any
  }

  public async delete(token: IToken, id): Promise<any> {
    return (await this.spreeResponse(
      'delete',
      Routes.adjustmentPath(id),
      token,
      {},
    )) as any
  }
}
